<template>
<transition name="scroll">
    <div v-if="show" @click="scrollToTop" class="btn-up"></div>
</transition>
</template>

<script>
import { throttle } from 'throttle-debounce';
export default {
    name: 'ScrollToTop',
    data() {
        return {
            show: false
        }
    },
    mounted() {
        window.addEventListener('scroll', throttle(300, () => {
            const scrollY = window.scrollY || document.documentElement.scrollTop;
            scrollY > 400 ? this.show = true : this.show = false;
        }));
    },
    methods: {
        scrollToTop() {
            const header = document.getElementById('header-nav');
            this.$smoothScroll({
                scrollTo: header,
            })
        }
    },

}
</script>

<style lang="scss" scoped>
.btn-up {
    position: fixed;
    right: 16px;
    bottom: 33px;
    border-radius: 50%;
    cursor: pointer;
    width: 40px;
    height: 40px;
    z-index: 101;

    @media(min-width: 560px) {
        width: 48px;
        height: 48px;
        bottom: 25px;
    }

    @media(min-width: 1300px) {
        right: 40px;
        bottom: 25px;
    }
}

.btn-up::before {
    content: "";
    text-align: center;
    position: absolute;
    width: 40px;
    height: 40px;
    left: 0;
    top: 0;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='40' height='40' viewBox='0 0 40 40' fill='none'%3E%3Crect width='40' height='40' rx='20' fill='%2382BF00'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M15.7578 18.8048C15.4974 18.5445 15.4974 18.1224 15.7578 17.862L19.529 14.0908C19.7893 13.8304 20.2115 13.8304 20.4718 14.0908L24.243 17.862C24.5034 18.1224 24.5034 18.5445 24.243 18.8048C23.9827 19.0652 23.5606 19.0652 23.3002 18.8048L20.6671 16.1716V25.438C20.6671 25.8062 20.3686 26.1047 20.0004 26.1047C19.6322 26.1047 19.3337 25.8062 19.3337 25.438V16.1716L16.7006 18.8048C16.4402 19.0652 16.0181 19.0652 15.7578 18.8048Z' fill='white'/%3E%3C/svg%3E");

    @media(min-width: 560px) {
        width: 48px;
        height: 48px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'%3E%3Crect width='48' height='48' rx='24' fill='%2382BF00'/%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M17.6366 22.2072C17.2461 21.8167 17.2461 21.1835 17.6366 20.793L23.2935 15.1362C23.684 14.7456 24.3172 14.7456 24.7077 15.1362L30.3646 20.793C30.7551 21.1835 30.7551 21.8167 30.3646 22.2072C29.974 22.5977 29.3409 22.5977 28.9504 22.2072L25.0006 18.2575L25.0006 32.157C25.0006 32.7093 24.5529 33.157 24.0006 33.157C23.4483 33.157 23.0006 32.7093 23.0006 32.157L23.0006 18.2575L19.0509 22.2072C18.6603 22.5977 18.0272 22.5977 17.6366 22.2072Z' fill='white'/%3E%3C/svg%3E");
    }

}

.scroll-enter-active {
    transition: opacity 0.3s ease;
}

.scroll-leave-active {
    transition: opacity 0.3s ease;
}

.scroll-enter-from {
    opacity: 0;
}

.scroll-enter-to {
    opacity: 1;
}

.scroll-leave-from {
    opacity: 1;
}

.scroll-leave-to {
    opacity: 0;
}
</style>